import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    detect: Boolean,
    identifiers: Object
  }

  initialize() {
    this.updateClocks = this.updateClocks.bind(this);
  }

  connect() {
    this.removeDetectedGroup();

    if (this.detectValue) {
      this.addDetectedGroup();
    }

    this.updateClocks();
    this.refresh();

    $(this.element).on('show.bs.select', this.updateClocks);
  }

  disconnect() {
    $(this.element).off('show.bs.select', this.updateClocks);
    this.removeDetectedGroup();
  }

  addDetectedGroup() {
    const option = this.detectedOption();

    if (!option) {
      return;
    }

    const country = option.closest('optgroup[data-country]');
    const group = document.createElement('optgroup');
    group.label = 'Detected Timezone';
    group.setAttribute('data-detected-time-zone', 'true');

    const detected = option.cloneNode(true);
    detected.removeAttribute('selected');
    detected.selected = false;
    group.appendChild(detected);

    this.element.insertBefore(group, this.element.querySelector('optgroup'));

    if (country) {
      group.after(country);
    }
  }

  updateClocks() {
    const now = new Date();
    let changed = false;

    Array.from(this.element.options).forEach((option) => {
      const content = this.content(option, now);

      if (content && option.getAttribute('data-content') !== content) {
        option.setAttribute('data-content', content);
        changed = true;
      }
    });

    if (changed) {
      this.refresh();
    }
  }

  content(option, now) {
    const clock = this.clock(option.getAttribute('data-time-zone'), now);

    if (!clock || !option.getAttribute('data-content')) {
      return null;
    }

    const template = document.createElement('template');
    template.innerHTML = option.getAttribute('data-content');

    const offset = template.content.querySelector('.time-zone-option__offset');
    const time = template.content.querySelector('.time-zone-option__time');

    if (!offset || !time) {
      return null;
    }

    offset.textContent = clock.offset;
    time.textContent = clock.time;

    return template.innerHTML;
  }

  clock(zone, now) {
    if (!zone) {
      return null;
    }

    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: zone,
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'longOffset'
      }).formatToParts(now);

      const offset = parts.find((part) => part.type === 'timeZoneName').value;
      const time = parts.filter((part) => part.type !== 'timeZoneName').map((part) => part.value).join('').trim();

      return { offset: offset === 'GMT' ? 'GMT+00:00' : offset, time: time };
    } catch (error) {
      return null;
    }
  }

  detectedOption() {
    const name = this.identifiersValue[this.detectedIdentifier()];

    if (!name) {
      return null;
    }

    return Array.from(this.element.options).find((option) => option.value === name);
  }

  detectedIdentifier() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      return null;
    }
  }

  removeDetectedGroup() {
    this.element.querySelectorAll('optgroup[data-detected-time-zone]').forEach((group) => group.remove());
  }

  refresh() {
    if ($(this.element).data('selectpicker')) {
      $(this.element).selectpicker('refresh');
    }
  }
}
